import { render, staticRenderFns } from "./SolicitorLayout.vue?vue&type=template&id=19fc5fcb&scoped=true&"
import script from "./SolicitorLayout.vue?vue&type=script&lang=js&"
export * from "./SolicitorLayout.vue?vue&type=script&lang=js&"
import style0 from "./SolicitorLayout.vue?vue&type=style&index=0&id=19fc5fcb&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19fc5fcb",
  null
  
)

export default component.exports